import { render, staticRenderFns } from "./CategoryGroupsDetails.vue?vue&type=template&id=4de8f732&scoped=true&"
import script from "./CategoryGroupsDetails.vue?vue&type=script&lang=js&"
export * from "./CategoryGroupsDetails.vue?vue&type=script&lang=js&"
import style0 from "./CategoryGroupsDetails.vue?vue&type=style&index=0&id=4de8f732&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de8f732",
  null
  
)

export default component.exports